import GiftTable from './MyGiftTable';
import BaseInfo from './BaseInfo/Form';
import Customization from './Customization';
import MyCoupon from './MyCoupon';
import styles from './styles.module.scss';
import Documentation from './Documentation';

function GiftTableParent(props) {
  return <GiftTable {...props} showFilterByOrder={false} />
}

export const LIST_OF_SECTIONS = [
  {
    id: 'my_table',
    title: 'Mi mesa',
    Section: GiftTableParent,
    verify:false,
  },
  {
    id: 'general_data',
    title: 'Datos generales',
    Section: BaseInfo,
    verify:false,
  },
  /*{
    id: 'customization',
    title: 'Personalización',
    Section: Customization,
    verify:false,
  },*/
  {
    id: 'coupon',
    title: 'Mi cupón',
    Section: MyCoupon,
    className: styles.tabMyCoupon,
    verify:false,
  },
  {
    id: 'documents',
    title: 'Documentos',
    Section: Documentation,
    verify:true,
  }
];

export const LIST_OF_SECTIONS_WITHOUT_COUPON = [
  {
    id: 'my_table',
    title: 'Mi mesa',
    Section: GiftTableParent,
    verify:false,
  },
  {
    id: 'general_data',
    title: 'Datos generales',
    Section: BaseInfo,
    verify:false,
  },
 /*{
    id: 'customization',
    title: 'Personalización',
    Section: Customization,
    verify:false,
  },*/
  {
    id: 'documents',
    title: 'Documentos',
    Section: Documentation,
    verify:true,
  }
];

export const OPTIONS_OF_SECTIONS = LIST_OF_SECTIONS.map((section, i) => ({
  ...section,
  value: i.toString(),
  label: section.title,
}));

export const OPTIONS_OF_SECTIONS_WITHOUT_COUPON = LIST_OF_SECTIONS_WITHOUT_COUPON.map((section, i) => ({
  ...section,
  value: i.toString(),
  label: section.title,
}));
